/** Workspace context is navigation state, never authority. */
export function workspaceFromRoute(
    pathname: string,
    search: string
): string | null {
    const params = new URLSearchParams(search);
    const organization = pathname.match(/^\/orgs\/([^/]+)(?:\/|$)/)?.[1];
    if (organization) {
        try {
            return decodeURIComponent(organization);
        } catch {
            return organization;
        }
    }
    if (pathname === "/servers/new" && params.get("org_id"))
        return params.get("org_id");
    return params.get("workspace");
}

export function workspaceHref(path: string, workspace: string, project?: string | null): string {
    const [base, fragment] = path.split("#", 2);
    const [pathname, query] = base.split("?", 2);
    const params = new URLSearchParams(query);
    params.set("workspace", workspace);
    if (project) params.set("project", project);
    if (pathname === "/servers/new") {
        if (workspace === "personal") params.delete("org_id");
        else params.set("org_id", workspace);
    }
    return `${pathname}?${params.toString()}${fragment ? `#${fragment}` : ""}`;
}

export function safeReturnPath(
    value: string | null,
    fallback = "/welcome"
): string {
    return value?.startsWith("/") &&
        !value.startsWith("//") &&
        !value.includes("\\") &&
        !/[\u0000-\u0020\u007f]/.test(value)
        ? value
        : fallback;
}
